/* =====================================================================
   SDWT Reserve Flow — 5-step booking wizard (front-end only)
   Backend (payment/inventory/emails) to be integrated later.
   ===================================================================== */
(function () {
  "use strict";

  var DEMO_TOURS = [
    { id:"jun06", day:"06", when:"June · Saturday", band:"25-34", iso:"20260606", nice:"Sat Jun 06", dateLong:"Saturday 06 June", city:"Melbourne", lunch:["Roast lunch","Vegetarian option","Grazing platter"],
      desc:"Long lunch at Oakridge · sparkling tasting at Domaine Chandon", price:149, gendered:true, femaleSeats:0, maleSeats:6, femaleVariant:null, maleVariant:null, seats:6, cap:16, status:"SELLING FAST" },
    { id:"jun20", day:"20", when:"June · Saturday", band:"35-44", iso:"20260620", nice:"Sat Jun 20", dateLong:"Saturday 20 June", city:"Melbourne", lunch:["Roast lunch","Vegetarian option","Grazing platter"],
      desc:"Winter pinot flight · fireside grazing at Stones of the Yarra", price:149, gendered:true, femaleSeats:6, maleSeats:6, femaleVariant:null, maleVariant:null, seats:12, cap:16, status:"STEADY" },
    { id:"jul04", day:"04", when:"July · Saturday", band:"25-34", iso:"20260704", nice:"Sat Jul 04", dateLong:"Saturday 04 July", city:"Melbourne", lunch:["Roast lunch","Vegetarian option","Grazing platter"],
      desc:"New release tasting at Yering Station · long table at Innocent Bystander", price:149, gendered:true, femaleSeats:8, maleSeats:8, femaleVariant:null, maleVariant:null, seats:16, cap:16, status:"WIDE OPEN" }
  ];
  /* Live tours come from Shopify (injected by the theme as window.SDWT_TOURS).
     window.SDWT_EXTRA_TOURS lets a single page (e.g. the private Queer Men's event)
     inject an extra bookable tour that stays hidden from the public "Choose tour" list.
     Falls back to the demo list when running locally / off the store. */
  var _rawTours = (typeof window.SDWT_TOURS !== 'undefined' && window.SDWT_TOURS) ? window.SDWT_TOURS.slice() : null;
  if (typeof window.SDWT_EXTRA_TOURS !== 'undefined' && window.SDWT_EXTRA_TOURS && window.SDWT_EXTRA_TOURS.length) {
    _rawTours = (_rawTours || []).concat(window.SDWT_EXTRA_TOURS);
  }
  var TOURS = _rawTours ? normalizeLiveTours(_rawTours) : DEMO_TOURS;
  TOURS.sort(function(a,b){ var ai=a.iso||'99999999', bi=b.iso||'99999999'; return ai<bi?-1:(ai>bi?1:0); });
  function normalizeLiveTours(arr){
    var MON={jan:['01','Jan'],feb:['02','Feb'],mar:['03','Mar'],apr:['04','Apr'],may:['05','May'],jun:['06','Jun'],jul:['07','Jul'],aug:['08','Aug'],sep:['09','Sep'],oct:['10','Oct'],nov:['11','Nov'],dec:['12','Dec']};
    var WD={Mon:'Monday',Tue:'Tuesday',Wed:'Wednesday',Thu:'Thursday',Fri:'Friday',Sat:'Saturday',Sun:'Sunday'};
    var MONFULL={jan:'January',feb:'February',mar:'March',apr:'April',may:'May',jun:'June',jul:'July',aug:'August',sep:'September',oct:'October',nov:'November',dec:'December'};
    var CITIES=['Adelaide','Melbourne','Sydney','Brisbane','Perth','Hobart','Canberra','Darwin','Gold Coast','Newcastle','Auckland','Queenstown'];
    return arr.map(function(r){
      var title = r.title || r.nice || '';
      var band = (title.match(/\(([^)]+)\)/)||[])[1] || r.band || '';
      var dm = title.match(/(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3})[a-z]*\s+(\d{4})/);
      var wd = (title.match(/\b(Mon|Tue|Wed|Thu|Fri|Sat|Sun)/)||[])[1] || 'Sat';
      var day='', iso='', monAbbr='', monFull='';
      if(dm){ var d=('0'+dm[1]).slice(-2); var mk=dm[2].toLowerCase(); var mm=MON[mk]?MON[mk][0]:'01'; monAbbr=MON[mk]?MON[mk][1]:dm[2]; monFull=MONFULL[mk]||monAbbr; day=d; iso=dm[3]+mm+d; }
      var _hasDate = !!dm;
      var _wdFull=(WD[wd]||'Saturday');
      var dateLong = _hasDate ? (day ? (_wdFull+' '+day+' '+monFull) : _wdFull) : 'Date to be confirmed';
      var _city=''; var _tl=title.toLowerCase();
      for(var _ci=0; _ci<CITIES.length; _ci++){ if(_tl.indexOf(CITIES[_ci].toLowerCase())>-1){ _city=CITIES[_ci]; break; } }
      if(!_city) _city = r.city || '';
      var _nz = (_city==='Auckland' || _city==='Queenstown' || /,\s*nz\b/i.test(title) || /\bnew zealand\b/i.test(title));
      var cap=r.cap||16;
      var _vars = r.variants || (r.variantId!=null ? [{gender:'', id:r.variantId, seats:(r.seats!=null?r.seats:cap)}] : []);
      var _male=null, _female=null, _total=0;
      _vars.forEach(function(vv){ var g=(''+(vv.gender||'')).toLowerCase(); var se=(vv.seats!=null?vv.seats:0); _total+=se;
        if(g.indexOf('female')>-1) _female={variantId:vv.id, seats:se}; else if(g.indexOf('male')>-1) _male={variantId:vv.id, seats:se}; });
      var _gendered = !!(_male && _female);
      var _single = _vars.length ? _vars[0].id : (r.variantId||r.id);
      var seats = _gendered ? _total : (_vars.length ? _vars[0].seats : (r.seats!=null?r.seats:cap));
      var status = seats<=0 ? 'SOLD OUT' : (seats>=cap ? 'WIDE OPEN' : (seats<=4 ? 'NEARLY FULL' : (seats<=8 ? 'SELLING FAST' : 'STEADY')));
      return { id:(r.id||r.handle||title), variantId:_single, day:day, gendered:_gendered, femaleVariant:(_female?_female.variantId:_single), femaleSeats:(_female?_female.seats:seats), maleVariant:(_male?_male.variantId:_single), maleSeats:(_male?_male.seats:seats),
        when:(_hasDate ? ((monAbbr?monAbbr+' · ':'')+(WD[wd]||'Saturday')) : 'Date TBC'), band:band, dateLong:dateLong, city:_city, nz:_nz, lunch:(r.lunch||[]), region:(r.region||''), iso:iso,
        nice:(_hasDate ? ((wd+' '+monAbbr+' '+day).trim()) : 'Date to be confirmed'), desc:(r.desc||''), price:(r.price||0),
        seats:seats, cap:cap, status:status, hidden:!!r.hidden, fixedGender:(r.fixedGender||null), soloOnly:!!r.soloOnly, relationshipQ:!!r.relationshipQ, label:(r.label||'') };
    });
  }
  var FEE = 5;
  var MATE_DISCOUNT = 20; /* $ off each ticket when booking a mate (matches the Shopify automatic discount) */
  /* ---- SHORT-TERM NZ pricing (pending Bankful multi-currency) ----
     NZ events are DISPLAYED in NZD but CHARGED in AUD. The real charge is always the
     Shopify variant price (AUD); everything below is display only. Matt locked 2026-10-07:
     charge A$119, show NZ$149, and show the bring-a-mate saving as NZ$20 off (so mates
     read NZ$129 each). NZD_PER_AUD turns the A$119 price into the NZ$149 sticker. The real
     NZ mate: shown as NZ$20 off (NZ$129), but the REAL Shopify discount on NZ tours is
     A$16 (≈NZ$20) via a separate "Bring a Mate NZ" automatic discount — so we don't over-
     discount (A$20 would be ≈NZ$25). Everything then converts at one rate: NZ$149=A$119,
     NZ$129=A$103, NZ$20 off=A$16. If the AUD charge changes, update NZD_PER_AUD (and keep
     the NZ product price + the NZ Shopify discount in sync). */
  var NZD_PER_AUD = 149/119;
  var NZ_OFF = 20;                                 /* NZ$ shown off per person on NZ tours (display only) */
  var NZ_REAL_OFF = 16;                            /* A$ actually discounted per mate on NZ tours (matches the "Bring a Mate NZ" Shopify discount) */
  function _cur(t){ return (t && t.nz) ? 'NZ$' : '$'; }
  function _suf(t){ return (t && t.nz) ? '' : ' AUD'; }
  function _stk(t){ return (t && t.nz) ? Math.round(t.price * NZD_PER_AUD) : (t ? t.price : 0); } /* display/sticker price */
  function _off(t){ return (t && t.nz) ? NZ_OFF : MATE_DISCOUNT; }                                /* display/sticker per-person discount */
  function _realOff(t){ return (t && t.nz) ? NZ_REAL_OFF : MATE_DISCOUNT; }                       /* real A$ discount per mate (for the "charged in AUD" figure) */
  function fmt(t, amt){ return _cur(t) + amt + _suf(t); }                                         /* e.g. "NZ$149" or "$149 AUD" */
  function audAmt(aud){ return 'A$' + aud; }
  var STEP_NAMES = ["Choose Tour","About You","Your Details","Review & Pay","Confirmed"];
  var IC_CHECK = '<svg viewBox="0 0 24 24" width="13" height="13" style="vertical-align:-1px;margin-right:6px" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4 4L19 7"/></svg>';
  var IC_CAL = '<svg viewBox="0 0 24 24" width="14" height="14" style="vertical-align:-2px;margin-right:7px" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="4.5" width="18" height="16.5" rx="2.5"/><path d="M3 9.5h18M8 2.5v4M16 2.5v4"/></svg>';
  var IC_SHARE = '<svg viewBox="0 0 24 24" width="14" height="14" style="vertical-align:-2px;margin-right:7px" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M8 8l4-4 4 4M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"/></svg>';
  var LOGO = (document.querySelector('.logo img') ? document.querySelector('.logo img').getAttribute('src') : 'assets/images/SDWT_Wordmark-2-1024x317.png');
  /* Optional white-label branding: a page can set window.SDWT_BRAND = { name:"...", logo:"" }
     to override the SDWT name/logo in the pop-up (logo:"" -> show the name as text, no logo).
     Unset on normal pages, so the default SDWT branding is unchanged. */
  var BRAND = (typeof window.SDWT_BRAND === 'object' && window.SDWT_BRAND) ? window.SDWT_BRAND : {};
  var BRAND_NAME = BRAND.name || 'The Speed Dating Wine Tour';
  var BRAND_LOGO = ('logo' in BRAND) ? BRAND.logo : LOGO;

  /* === Shopify checkout config ===
     After creating the products in Shopify, paste each variant's numeric ID below.
     While these are null (or when not on the Shopify store) the flow runs as a local demo. */
  var CONFIG = {
    tourVariants: { jun06: null, jun20: null, jul04: null },
    bookingFeeVariantId: (typeof window.SDWT_FEE_VARIANT !== 'undefined' ? window.SDWT_FEE_VARIANT : null)
  };
  function shopifyReady(t){ return (typeof window.Shopify !== 'undefined') && t && (t.variantId || CONFIG.tourVariants[t.id]); }

  var ERR_CSS = '.rsv-errbanner{background:#FBE9E7;color:#B83227;border:1px solid #f1c0b9;border-radius:14px;padding:13px 18px;font-family:var(--font-body);font-size:15px;margin:0 0 24px;}' +
    '.rsv-fielderr{color:#B83227;font-family:var(--font-ui);font-size:12px;margin-top:5px;}' +
    '.rsv-field.err input,.rsv-field.err textarea{border-color:#B83227;}' +
    '.rsv-q.err .rsv-q-title{color:#B83227;}' +
    '.rsv-empty{font-family:var(--font-body);font-size:18px;line-height:28px;color:#6f6f6f;background:#FEF4E4;border-radius:24px;padding:48px 32px;text-align:center;}';

  var s = {};
  function newMate(){ return { first:"", last:"", email:"", mobile:"", mobileCC:"", age:"", gender:"", lunch:"" }; }
  /* phone country code: NZ events default to +64, everything else +61; the booker/mate can override via the picker */
  function defCC(){ return (s.tour && s.tour.nz) ? '+64' : '+61'; }
  function fmtPhone(cc, mob){ return (cc||defCC()) + ' ' + (mob||'').replace(/^0/,''); }
  function reset(){ s = { step:0, errs:[], errMsg:"", ref:"", tour:null, ticketType:'single', identify:null, ageGroup:null, hopes:[], energy:null, relationship:null, lunch:null,
    dietary:"", accessibility:"", firstName:"", lastName:"", email:"", mobile:"", mobileCC:"", dob:"", age:"", instagram:"",
    mates:[],
    emName:"", emPhone:"", pickup:null, note:"", terms:false, card:"", exp:"", cvc:"", cardName:"" }; }
  reset();
  function groupSize(){ return 1 + (s.ticketType==='mate' ? s.mates.length : 0); }

  var root;
  function el(html){ var d=document.createElement('div'); d.innerHTML=html.trim(); return d.firstChild; }
  function esc(x){ return (x||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function isErr(k){ return s.errs.indexOf(k) > -1; }
  /* Past-tour guard: hide tours whose date has already passed from the Choose-tour list.
     Uses Australian (Melbourne) date; tour.iso is YYYYMMDD parsed from the title. */
  function todayISO(){
    try { return new Date().toLocaleDateString('en-CA', {timeZone:'Australia/Melbourne'}).replace(/-/g,''); }
    catch(e){ var d=new Date(); return ''+d.getFullYear()+('0'+(d.getMonth()+1)).slice(-2)+('0'+d.getDate()).slice(-2); }
  }
  function isPastTour(t){ return t && t.iso && /^\d{8}$/.test(t.iso) && t.iso <= todayISO(); }

  function build(){
    var st = document.createElement('style'); st.textContent = ERR_CSS; document.head.appendChild(st);
    root = el(
      '<div class="rsv-overlay" id="rsvOverlay" role="dialog" aria-modal="true">' +
        '<div class="rsv-top">' +
          (BRAND_LOGO ? '<a class="rsv-logo" href="/"><img src="'+BRAND_LOGO+'" alt="Speed Dating Wine Tour"></a>' : '<span class="rsv-logo rsv-logo-text" style="font-family:var(--font-heading,Georgia,serif);font-size:21px;font-weight:600;color:#8b3b35;">'+esc(BRAND_NAME)+'</span>') +
          '<div class="rsv-top-right">'+(BRAND.name ? '' : '<a class="rsv-help" href="/pages/contact" target="_blank" rel="noopener">Need help?</a>')+'<button class="rsv-close" aria-label="Close">×</button></div>' +
        '</div>' +
        '<div class="rsv-progress">' +
          '<div class="rsv-progress-row"><span class="rsv-stepnum">STEP <b>1</b> OF 5</span><span class="rsv-stepname">CHOOSE TOUR</span></div>' +
          '<div class="rsv-bar"><span style="width:20%"></span></div>' +
        '</div>' +
        '<div class="rsv-container"><div class="rsv-panel" id="rsvPanel"></div></div>' +
      '</div>'
    );
    document.body.appendChild(root);
    root.querySelector('.rsv-close').addEventListener('click', close);
    render();
  }

  function open(preTour){ if(!root) build(); reset(); if(preTour){ var _pt=TOURS.filter(function(x){return x.id===preTour;})[0]; if(_pt){ s.tour=_pt; s.step=1; } } document.body.classList.add('rsv-locked'); root.classList.add('open'); render(); root.scrollTop=0; }
  function close(){ if(root){ root.classList.remove('open'); document.body.classList.remove('rsv-locked'); } }

  function setProgress(){
    var n = s.step + 1;
    root.querySelector('.rsv-stepnum').innerHTML = 'STEP <b>'+n+'</b> OF 5';
    root.querySelector('.rsv-stepname').textContent = STEP_NAMES[s.step].toUpperCase();
    root.querySelector('.rsv-bar span').style.width = (n*20)+'%';
  }

  function go(n){ s.step = n; s.errs = []; render(); root.scrollTop = 0; }

  function render(){
    setProgress();
    var p = root.querySelector('#rsvPanel');
    if (s.step===0) p.innerHTML = step1();
    else if (s.step===1) p.innerHTML = step2();
    else if (s.step===2) p.innerHTML = step3();
    else if (s.step===3) p.innerHTML = step4();
    else p.innerHTML = step5();
    bind();
  }

  function banner(){ return s.errs.length ? '<div class="rsv-errbanner">'+s.errMsg+'</div>' : ''; }

  /* ---------- STEP 1 ---------- */
  function step1(){
    var visibleTours = TOURS.filter(function(t){ return !t.hidden && !isPastTour(t); });
    var cards = visibleTours.map(function(t){
      return '<button class="rsv-tour'+(s.tour&&s.tour.id===t.id?' sel':'')+'" data-tour="'+t.id+'">' +
        '<span class="rsv-tour-info">' +
          (t.city?'<span class="rsv-tour-city">'+t.city+'</span>':'') +
          '<span class="rsv-tour-date">'+(t.dateLong||t.when)+'</span>' +
          '<span class="rsv-tour-band">Age band · '+t.band+'</span>' +
          '<p class="rsv-tour-desc">'+t.desc+'</p>' +
        '</span>' +
        '<span class="rsv-tour-right"><p class="rsv-tour-price">'+fmt(t,_stk(t))+'</p>'+(t.nz?'<p class="rsv-tour-aud" style="font-size:11px;color:#8a7d6d;margin:2px 0 0;font-weight:500;">charged in AUD</p>':'')+'</span>' +
      '</button>';
    }).join('');
    return '<div class="rsv-eyebrow">Choose your tour</div>' +
      '<p class="rsv-lead">Pick the one that fits your calendar and your crowd. We balance the bus by age and energy, so age band matters.</p>' +
      banner() + (visibleTours.length ? '<div class="rsv-tours">'+cards+'</div>'
        : '<div class="rsv-empty">No tours are open for booking right now. Check back soon. New dates are added regularly.</div>');
  }

  /* ---------- STEP 2 ---------- */
  function optGroup(key, num, title, hint, opts, multi, disabled){
    disabled = disabled || {};
    var btns = opts.map(function(o){
      var on = multi ? s[key].indexOf(o)>-1 : s[key]===o;
      if(disabled[o]) return '<button class="rsv-opt rsv-opt-out" disabled>'+o+' <em>'+disabled[o]+'</em></button>';
      return '<button class="rsv-opt'+(on?' sel':'')+'" data-grp="'+key+'" data-val="'+esc(o)+'" data-multi="'+(multi?1:0)+'">'+o+'</button>';
    }).join('');
    return '<div class="rsv-q'+(isErr(key)?' err':'')+'"><div class="rsv-q-num">'+num+'</div><div class="rsv-q-title">'+title+'</div>' +
      (hint?'<div class="rsv-q-hint">'+hint+'</div>':'') + '<div class="rsv-opts">'+btns+'</div>' +
      (isErr(key)?'<div class="rsv-fielderr">Please choose an option.</div>':'') + '</div>';
  }
  function genderSoldOut(){
    var gd={};
    if(s.tour && s.tour.gendered){
      if(s.tour.femaleSeats<=0) gd['Female']='Sold out';
      if(s.tour.maleSeats<=0) gd['Male']='Sold out';
    }
    return gd;
  }
  function ticketTypeSelector(){
    if(s.tour && s.tour.soloOnly){ s.ticketType='single'; return ''; }  /* solo-only event (e.g. The Reunion): no "bring friends" option */
    var p1 = s.tour ? s.tour.price : 149;
    var matePer = p1 - MATE_DISCOUNT;
    return '<div class="rsv-q"><div class="rsv-q-title">Ticket type</div>' +
      '<div class="rsv-q-hint">Bring one or more friends and you each save '+fmt(s.tour,_off(s.tour))+'.</div>' +
      '<div class="rsv-opts rsv-tickettype">' +
        '<button class="rsv-opt'+(s.ticketType==='single'?' sel':'')+'" data-tt="single">Just me &middot; '+fmt(s.tour,_stk(s.tour))+'</button>' +
        '<button class="rsv-opt'+(s.ticketType==='mate'?' sel':'')+'" data-tt="mate">Bring friends &middot; '+fmt(s.tour,_stk(s.tour)-_off(s.tour))+' each ('+fmt(s.tour,_off(s.tour))+' off per person)</button>' +
      '</div></div>';
  }
  function step2(){
    var gd = genderSoldOut();
    var fixedG = s.tour && s.tour.fixedGender;            /* single-gender event (e.g. Queer Men's) → skip the gender question */
    if(fixedG){ s.identify = fixedG; }
    else if(s.tour && s.tour.gendered){
      if(gd['Female'] && s.identify==='Female') s.identify=null;
      if(gd['Male'] && s.identify==='Male') s.identify=null;
    }
    var hasLunch = !!(s.tour && s.tour.lunch && s.tour.lunch.length);
    var qn = 0; function nn(){ qn++; return ('0'+qn).slice(-2); }
    var genderQ = fixedG ? '' : optGroup('identify', nn(), 'Gender','', ['Female','Male'], false, gd);
    var ageQ    = optGroup('ageGroup', nn(), 'What’s your age group?','', ['25-34','35-44','45-54','55+'], false);
    var hopesQ  = optGroup('hopes', nn(), 'What are you hoping to get from the day?','Pick as many as feel true.', ['Real connection','Open to meeting someone','A great day out','Make friends','Curious to try something new'], true);
    var energyQ = optGroup('energy', nn(), 'How would you describe your energy on a social day out?','Honest answers only. We read the room for you.', ['Quiet observer','Warm but reserved','Easy chatter','Life of the party'], false);
    var relQ    = (s.tour && s.tour.relationshipQ) ? optGroup('relationship', nn(), 'What’s your current relationship status?','', ['Single','It’s complicated','In a relationship','Married'], false) : '';
    var lunchQ  = hasLunch ? optGroup('lunch', nn(), 'Lunch choice','Select your lunch option for the day', s.tour.lunch, false) : '';
    var dn = nn();
    var an = nn();
    return '<div class="rsv-eyebrow">About you</div>' +
      banner() +
      ticketTypeSelector() +
      genderQ + ageQ + hopesQ + energyQ + relQ + lunchQ +
      '<div class="rsv-q"><div class="rsv-q-num">'+dn+'</div><div class="rsv-q-title">Any dietary requirements?</div><div class="rsv-q-hint">Optional. We brief the venues ahead of time.</div>' +
        '<div class="rsv-field"><input type="text" data-f="dietary" value="'+esc(s.dietary)+'" placeholder="e.g. Vegetarian, gluten-free, nut allergy"></div></div>' +
      '<div class="rsv-q"><div class="rsv-q-num">'+an+'</div><div class="rsv-q-title">Any accessibility needs we should know about?</div><div class="rsv-q-hint">Optional. We’ll quietly make sure the day works for you.</div>' +
        '<div class="rsv-field"><input type="text" data-f="accessibility" value="'+esc(s.accessibility)+'" placeholder="e.g. Step-free access, hearing support"></div></div>' +
      nav(!(s.tour && s.tour.hidden),'Continue');   /* single-event direct link (e.g. Queer Men's): no "Back", there's no tour list to return to */
  }

  /* ---------- STEP 3 ---------- */
  /* country-code <option>s for the phone prefix picker (AU default, NZ added) */
  function ccOptions(sel){
    return [['+61','🇦🇺 +61'],['+64','🇳🇿 +64']].map(function(c){
      return '<option value="'+c[0]+'"'+(c[0]===sel?' selected':'')+'>'+c[1]+'</option>';
    }).join('');
  }
  function fld(label, key, opts){
    opts=opts||{};
    var t = opts.type||'text';
    var req = opts.req?' <span class="req">*</span>':'';
    var note = opts.note?'<span class="note">'+opts.note+'</span>':'';
    var ph = opts.ph?' placeholder="'+esc(opts.ph)+'"':'';
    var extra = opts.attr?(' '+opts.attr):'';
    var e = isErr(key);
    var input = '<input type="'+t+'" data-f="'+key+'" value="'+esc(s[key])+'"'+ph+extra+'>';
    if(opts.cc){ var ck=key+'CC';
      input = '<div class="rsv-phone"><select class="rsv-ccsel" data-f="'+ck+'">'+ccOptions(s[ck]||defCC())+'</select>'+input+'</div>'; }
    return '<div class="rsv-field'+(e?' err':'')+'" data-wrap="'+key+'"><label>'+label+req+note+'</label>' +
      input +
      (e?'<div class="rsv-fielderr">'+(opts.errMsg||(label+' is required'))+'</div>':'') + '</div>';
  }
  /* one indexed friend field */
  function mfld(label, key, i, opts){
    opts=opts||{};
    var t = opts.type||'text';
    var req = opts.req?' <span class="req">*</span>':'';
    var note = opts.note?'<span class="note">'+opts.note+'</span>':'';
    var ph = opts.ph?' placeholder="'+esc(opts.ph)+'"':'';
    var errKey = 'mate_'+key+'_'+i;
    var e = isErr(errKey);
    var val = s.mates[i] ? s.mates[i][key] : '';
    var input = '<input type="'+t+'" data-mf="'+key+'" data-mate="'+i+'" value="'+esc(val)+'"'+ph+'>';
    if(opts.cc){ var ck=key+'CC'; var selCC=(s.mates[i] && s.mates[i][ck]) || defCC();
      input = '<div class="rsv-phone"><select class="rsv-ccsel" data-mf="'+ck+'" data-mate="'+i+'">'+ccOptions(selCC)+'</select>'+input+'</div>'; }
    return '<div class="rsv-field'+(e?' err':'')+'"><label>'+label+req+note+'</label>' +
      input +
      (e?'<div class="rsv-fielderr">'+(opts.errMsg||(label+' is required'))+'</div>':'') + '</div>';
  }
  /* which genders are unavailable for friend #idx, given seats already claimed by booker + other friends */
  function mateGenderDisabled(idx){
    var gd = {};
    if(!(s.tour && s.tour.gendered)) return gd;
    ['Female','Male'].forEach(function(g){
      var seats = g==='Female' ? s.tour.femaleSeats : s.tour.maleSeats;
      var claimed = (s.identify===g?1:0);
      s.mates.forEach(function(m,i){ if(i!==idx && m.gender===g) claimed++; });
      if(seats - claimed <= 0) gd[g] = 'Sold out';
    });
    return gd;
  }
  /* one friend's block of fields */
  function mateFieldsBlock(m, i){
    var fixedG = s.tour && s.tour.fixedGender;           /* single-gender event → skip friend gender pills */
    if(fixedG && !m.gender) m.gender = fixedG;
    var genderQ = '';
    if(!fixedG){
      var gd = mateGenderDisabled(i);
      var genderPills = ['Female','Male'].map(function(g){
        if(gd[g] && m.gender!==g) return '<button class="rsv-opt rsv-opt-out" disabled>'+g+' <em>'+gd[g]+'</em></button>';
        return '<button class="rsv-opt'+(m.gender===g?' sel':'')+'" data-mate-grp="gender" data-mate="'+i+'" data-val="'+g+'">'+g+'</button>';
      }).join('');
      genderQ = '<div class="rsv-q'+(isErr('mate_gender_'+i)?' err':'')+'"><div class="rsv-q-title">Their gender <span class="req">*</span></div>' +
        '<div class="rsv-opts">'+genderPills+'</div>' +
        (isErr('mate_gender_'+i)?'<div class="rsv-fielderr">Please choose their gender.</div>':'') + '</div>';
    }
    var lunchQ = '';
    if(s.tour && s.tour.lunch && s.tour.lunch.length){
      var lunchPills = s.tour.lunch.map(function(l){
        return '<button class="rsv-opt'+(m.lunch===l?' sel':'')+'" data-mate-grp="lunch" data-mate="'+i+'" data-val="'+esc(l)+'">'+esc(l)+'</button>';
      }).join('');
      lunchQ = '<div class="rsv-q'+(isErr('mate_lunch_'+i)?' err':'')+'"><div class="rsv-q-title">Their lunch choice <span class="req">*</span></div>' +
        '<div class="rsv-opts">'+lunchPills+'</div>' +
        (isErr('mate_lunch_'+i)?'<div class="rsv-fielderr">Please choose their lunch option.</div>':'') + '</div>';
    }
    return '<div class="rsv-mate-block" data-mate-block="'+i+'">' +
      '<div class="rsv-mate-head"><div class="rsv-mate-title">Friend '+(i+1)+'</div>' +
        '<button type="button" class="rsv-mate-remove" data-mate-remove="'+i+'">Remove</button></div>' +
      '<div class="rsv-grid2">'+mfld('First name','first',i,{req:1,ph:'Sam'})+mfld('Last name','last',i,{req:1,ph:'Taylor'})+'</div>' +
      mfld('Email','email',i,{req:1,type:'email',ph:'sam@example.com',errMsg:'A valid email is required'}) +
      '<div class="rsv-grid2">'+mfld('Mobile','mobile',i,{req:1,type:'tel',cc:1,note:'Digits only, no country code.',ph:'0412 345 678'})+mfld('Age','age',i,{req:1,type:'number',ph:'e.g. 34',note:bandNote(),errMsg:((m.age&&ageOutOfBand(m.age))?bandMsg():'Age is required')})+'</div>' +
      genderQ + lunchQ +
    '</div>';
  }
  /* running group subtotal shown under the friend blocks */
  function groupSubtotal(){
    var g = groupSize();
    var per = s.tour ? s.tour.price - MATE_DISCOUNT : 0;
    return '<div class="rsv-group-sub">Group of '+g+' &middot; <b>'+fmt(s.tour,(_stk(s.tour)-_off(s.tour))*g)+'</b> <span>('+fmt(s.tour,_stk(s.tour)-_off(s.tour))+' each, '+fmt(s.tour,_off(s.tour))+' off per person)</span></div>';
  }
  function mateSection(){
    if(s.ticketType!=='mate') return '';
    var blocks = s.mates.map(function(m,i){ return mateFieldsBlock(m,i); }).join('');
    return '<div class="rsv-section-h">Your friends</div>' +
      '<p class="rsv-lead">You\u2019re booking a group. Add each friend\u2019s details so we have their information for the day too. Everyone saves '+fmt(s.tour,_off(s.tour))+'.</p>' +
      blocks +
      '<button type="button" class="rsv-add-mate" data-add-mate>+ Add another friend</button>' +
      groupSubtotal();
  }

  function step3(){
    var _db = dobBounds();
    return '<div class="rsv-eyebrow">Your details</div>' +
      '<h2 class="rsv-h">Just enough to confirm your seat.</h2>' +
      '<p class="rsv-lead">We’ll never share these. Mobile is for tour-day logistics only.</p>' +
      banner() +
      '<div class="rsv-section-h">About you</div>' +
      '<div class="rsv-grid2">'+fld('First name','firstName',{req:1,ph:'Hannah'})+fld('Last name','lastName',{req:1,ph:'Nguyen'})+'</div>' +
      fld('Email','email',{req:1,type:'email',ph:'hannah@example.com',errMsg:'A valid email is required'}) +
      '<div class="rsv-grid2">'+fld('Mobile','mobile',{req:1,type:'tel',cc:1,note:'Digits only, no country code.',ph:'0412 345 678'})+fld('Date of birth','dob',{req:1,type:'date',note:bandNote(),errMsg:(dobOutOfBand(s.dob)?bandMsg():'Date of birth is required'),attr:'min="'+_db.min+'" max="'+_db.max+'"'})+'</div>' +
      '<div class="rsv-grid2">'+fld('Age','age',{req:1,type:'number',note:'Filled in from your date of birth',errMsg:((s.age&&ageOutOfBand(s.age))?bandMsg():'Please choose your date of birth above'),attr:'readonly style="background:#f4efe7;color:#6b5f54;cursor:default;"'})+fld('Instagram handle','instagram',{type:'text',note:'Optional',ph:'@yourhandle'})+'</div>' +
      mateSection() +
      '<div class="rsv-section-h">Anything else?</div>' +
      '<div class="rsv-field"><textarea data-f="note" placeholder="Birthday treat, vegetarian preference, friend on a different tour, anything we should know.">'+esc(s.note)+'</textarea></div>' +
      nav(true,'Continue');
  }

  /* ---------- STEP 4 ---------- */
  function step4(){
    var t = s.tour;
    var isMate = s.ticketType==='mate';
    var g = groupSize();
    var matePer = t.price - MATE_DISCOUNT;
    var total = isMate ? (t.price-_realOff(t))*g : t.price; /* real AUD charge (for the "charged in AUD" note) */
    var dispTotal = isMate ? (_stk(t)-_off(t))*g : _stk(t); /* what we show (NZ$ on NZ tours, else same AUD) */
    var priceRows = isMate
      ? '<div class="row"><span>Tour ticket &times; '+g+'</span><span>'+fmt(t,_stk(t)*g)+'</span></div>' +
        '<div class="row"><span>Group discount ('+fmt(t,_off(t))+' &times; '+g+')</span><span>&minus;'+fmt(t,_off(t)*g)+'</span></div>'
      : '<div class="row"><span>Tour ticket</span><span>'+fmt(t,_stk(t))+'</span></div>';
    var mateCard = isMate
      ? s.mates.map(function(m,i){
          return '<div class="rsv-rcard"><div class="rsv-rcard-h"><h4>Friend '+(i+1)+'</h4><button class="rsv-edit" data-goto="2">Edit</button></div>' +
            '<div class="rsv-rgrid">' +
              '<div><p class="rsv-rk">Name</p><p class="rsv-rv">'+esc((m.first+' '+m.last).trim())+'</p></div>' +
              '<div><p class="rsv-rk">Email</p><p class="rsv-rv">'+esc(m.email)+'</p></div>' +
              '<div><p class="rsv-rk">Mobile</p><p class="rsv-rv">'+esc(fmtPhone(m.mobileCC, m.mobile))+'</p></div>' +
              '<div><p class="rsv-rk">Gender</p><p class="rsv-rv">'+esc(m.gender)+'</p></div>' +
              '<div><p class="rsv-rk">Age</p><p class="rsv-rv">'+esc(m.age)+'</p></div>' +
              (m.lunch?'<div><p class="rsv-rk">Lunch</p><p class="rsv-rv">'+esc(m.lunch)+'</p></div>':'') +
            '</div></div>';
        }).join('')
      : '';
    return '<div class="rsv-eyebrow">Review & pay</div>' +
      '<h2 class="rsv-h">One last look before we lock it in.</h2>' +
      '<p class="rsv-lead">You’ll pay securely via Shopify checkout on the next screen. We never see or store your card details.</p>' +
      banner() +
      '<div class="rsv-rcard"><div class="rsv-rcard-h"><h4>Your tour</h4><button class="rsv-edit" data-goto="0">Edit</button></div>' +
        '<div class="rsv-rtour"><span class="d">'+t.day+'</span><span><p class="w">'+t.when+'</p>' +
        '<p class="m">'+(t.label?t.label+' · ':'')+(t.region||'Valley')+' Tour'+(t.band?' · Age band '+t.band:'')+'</p></span></div></div>' +
      '<div class="rsv-rcard"><div class="rsv-rcard-h"><h4>Your details</h4><button class="rsv-edit" data-goto="2">Edit</button></div>' +
        '<div class="rsv-rgrid">' +
          '<div><p class="rsv-rk">Name</p><p class="rsv-rv">'+esc(s.firstName+' '+s.lastName)+'</p></div>' +
          '<div><p class="rsv-rk">Email</p><p class="rsv-rv">'+esc(s.email)+'</p></div>' +
          '<div><p class="rsv-rk">Mobile</p><p class="rsv-rv">'+esc(fmtPhone(s.mobileCC, s.mobile))+'</p></div>' +
          '<div><p class="rsv-rk">Age</p><p class="rsv-rv">'+esc(s.age)+'</p></div>' +
          (s.instagram?'<div><p class="rsv-rk">Instagram</p><p class="rsv-rv">'+esc(s.instagram)+'</p></div>':'') +
        '</div></div>' +
      mateCard +
      '<div class="rsv-rcard rsv-price"><h4 style="font-family:var(--font-heading);font-size:19px;margin:0 0 12px;">Price</h4>' +
        priceRows +
        '<div class="total"><span class="lbl">Total</span><span class="amt">'+fmt(t,dispTotal)+'</span></div>' +
        (t.nz?'<p style="font-family:var(--font-body);font-size:13px;color:#6f6f6f;margin:8px 0 0;">Prices shown in NZD. You’ll be charged the equivalent in Australian dollars at checkout: <b>'+audAmt(total)+'</b>.</p>':'') +
        (isMate?'<p style="font-family:var(--font-body);font-size:13px;color:#6f6f6f;margin:8px 0 0;">Group discount ('+fmt(t,_off(t))+' off each) is applied automatically at checkout.</p>':'') + '</div>' +
      '<div class="rsv-badges"><span>'+IC_CHECK+'Secure checkout</span><span>'+IC_CHECK+'SSL encrypted</span><span>'+IC_CHECK+'Licensed & insured transport</span><span>'+IC_CHECK+'RSA-compliant venues</span></div>' +
      '<div class="rsv-rcard" style="text-align:center"><p style="font-family:var(--font-body);font-size:16px;line-height:24px;color:#6f6f6f;margin:0;">You’ll complete payment securely on the next screen via <b>Shopify checkout</b>. Your card details are never stored on our servers.</p></div>' +
      '<label class="rsv-terms"><input type="checkbox" data-f="terms"'+(s.terms?' checked':'')+'><span>I’ve read and accept the <a href="/pages/cancellation-policy" target="_blank">cancellation policy</a>.</span></label>' +
      (isErr('terms')?'<div class="rsv-fielderr" style="margin-left:2px">Please accept the cancellation policy to continue.</div>':'') +
      '<label class="rsv-terms"><input type="checkbox" data-f="tc"'+(s.tc?' checked':'')+'><span>I’ve read and agree to the <a href="/pages/terms-and-conditions" target="_blank">Terms &amp; Conditions</a> and <a href="/pages/privacy-policy" target="_blank">Privacy Policy</a>.</span></label>' +
      (isErr('tc')?'<div class="rsv-fielderr" style="margin-left:2px">Please accept the Terms &amp; Conditions and Privacy Policy to continue.</div>':'') +
      nav(true, (shopifyReady(t) ? 'Proceed to secure checkout' : 'Confirm booking '+fmt(t,dispTotal)), true);
  }

  /* ---------- STEP 5 ---------- */
  function bookingRef(){
    var c='ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789', r=''; for(var i=0;i<3;i++) r+=c[Math.floor(Math.random()*c.length)];
    var pre=(s.firstName.slice(0,3).toUpperCase()+'XXX').slice(0,3);
    return 'SDWT-'+s.tour.iso+'-'+pre+r;
  }
  function gcalLink(){
    var d=s.tour.iso;
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text='+encodeURIComponent('Speed Dating Wine Tour')+'&dates='+d+'T093000/'+d+'T180000&details='+encodeURIComponent((s.tour.region||'Valley')+' tour - booking '+s.ref);
  }
  function step5(){
    s.ref = s.ref || bookingRef();
    var total = s.ticketType==='mate' ? (s.tour.price-MATE_DISCOUNT)*groupSize() : s.tour.price;
    var dispTotal = s.ticketType==='mate' ? (_stk(s.tour)-_off(s.tour))*groupSize() : _stk(s.tour);
    return '<div class="rsv-confirm">' +
      '<div class="rsv-conf-badge">Booking confirmed</div>' +
      '<h2 class="rsv-conf-h">You’re in. <em>We can’t wait to host you.</em></h2>' +
      '<p class="rsv-conf-sub">We’ve sent a confirmation to <b>'+esc(s.email)+'</b>. Everything you need for the day arrives in the next 24 hours.</p>' +
      '<div class="rsv-ticket">' +
        '<div class="rsv-ticket-top"><div class="k">'+esc(BRAND_NAME)+'</div><div class="v">'+(s.tour.region||'Valley')+' · Boutique coach</div></div>' +
        '<div class="rsv-ticket-body">' +
          '<div class="rsv-ticket-row"><div><div class="k">Date</div><div class="v">'+s.tour.nice+'</div></div>' +
            (s.tour.band?'<div><div class="k">Age band</div><div class="v">'+s.tour.band+'</div></div>':'')+'</div>' +
          '<div class="rsv-ticket-div"></div>' +
          '<div class="rsv-ticket-ref"><div><div class="k">Booking ref</div><div class="v">'+s.ref+'</div></div>' +
            '<div style="text-align:right"><div class="k">Paid</div><div class="v">'+fmt(s.tour,dispTotal)+'</div></div></div>' +
        '</div></div>' +
      '<div class="rsv-cal-h">Add to calendar</div>' +
      '<div class="rsv-cal"><a href="'+gcalLink()+'" target="_blank">'+IC_CAL+'Google</a>' +
        '<a href="#" class="rsv-ics">'+IC_CAL+'Apple</a><a href="#" class="rsv-ics">'+IC_CAL+'Outlook</a></div>' +
      '<button class="rsv-share">'+IC_SHARE+'Share with a friend</button>' +
      '<div style="margin-top:26px"><span class="rsv-back-home">← Back to home</span></div>' +
    '</div>';
  }

  /* ---------- nav buttons ---------- */
  function nav(back, label, olive){
    return '<div class="rsv-nav">' +
      (back?'<button class="rsv-back">← Back</button>':'<span></span>') +
      '<button class="rsv-next'+(olive?' olive':'')+'" id="rsvNext">'+label+' →</button></div>';
  }

  /* ---------- per-tour age-band restriction ----------
     Blocks a booking when the entered Age (or the age implied by Date of birth) falls
     outside the tour's own age band (e.g. "25-45 y/o" -> 25 to 45, "55+" -> 55 and up).
     Tours with no band (e.g. The Reunion) are unrestricted. */
  function parseBand(band){
    if(!band) return null;
    var r = String(band).match(/(\d+)\s*[-–—]\s*(\d+)/);
    if(r) return { min:parseInt(r[1],10), max:parseInt(r[2],10) };
    var p = String(band).match(/(\d+)\s*\+/);
    if(p) return { min:parseInt(p[1],10), max:200 };
    return null;
  }
  function tourBand(){ return s.tour ? parseBand(s.tour.band) : null; }
  function dobToAge(dob){
    if(!dob) return null;
    var d = new Date(dob); if(isNaN(d.getTime())) return null;
    var n = new Date(), a = n.getFullYear()-d.getFullYear(), mo = n.getMonth()-d.getMonth();
    if(mo<0 || (mo===0 && n.getDate()<d.getDate())) a--;
    return (a>=0 && a<130) ? a : null;
  }
  function ageOutOfBand(age){ var b=tourBand(); if(!b) return false; var a=parseInt(age,10); if(isNaN(a)) return false; return a<b.min || a>b.max; }
  function dobOutOfBand(dob){ var b=tourBand(); if(!b) return false; var a=dobToAge(dob); if(a==null) return false; return a<b.min || a>b.max; }
  function bandMsg(){ var b=tourBand(); if(!b) return ''; return 'Sorry, this tour is for guests aged '+b.min+(b.max>=200?'+':('-'+b.max))+'.'; }
  function bandNote(){ var b=tourBand(); if(!b) return ''; return 'Ages '+b.min+(b.max>=200?'+':('-'+b.max))+' for this tour'; }
  function hasBandViolation(m){
    if(!tourBand()) return false;
    if(m.indexOf('age')>-1 && s.age && ageOutOfBand(s.age)) return true;
    if(m.indexOf('dob')>-1 && dobOutOfBand(s.dob)) return true;
    for(var i=0;i<s.mates.length;i++){ if(m.indexOf('mate_age_'+i)>-1 && s.mates[i].age && ageOutOfBand(s.mates[i].age)) return true; }
    return false;
  }
  /* Min/max birthdate for the date picker: no future dates, and within the tour's age range
     (or 18+ for open events). Keeps the DOB the single source of truth for age. */
  function dobBounds(){
    var b=tourBand(), now=new Date();
    var youngest = b ? b.min : 18;   /* youngest age allowed */
    var oldest   = b ? b.max : 100;  /* oldest age allowed  */
    function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
    return {
      max: iso(new Date(now.getFullYear()-youngest,   now.getMonth(), now.getDate())),      /* most recent DOB (youngest) */
      min: iso(new Date(now.getFullYear()-oldest-1,    now.getMonth(), now.getDate()+1))     /* oldest DOB */
    };
  }

  /* ---------- validation: returns array of missing field keys ---------- */
  function validate(){
    var m = [];
    if (s.step===0){ if(!s.tour) m.push('tour'); }
    else if (s.step===1){ if(!s.identify)m.push('identify'); if(!s.ageGroup)m.push('ageGroup'); if(!s.hopes.length)m.push('hopes'); if(!s.energy)m.push('energy'); if(s.tour && s.tour.relationshipQ && !s.relationship)m.push('relationship'); if(s.tour && s.tour.lunch && s.tour.lunch.length && !s.lunch)m.push('lunch'); }
    else if (s.step===2){
      if(!s.firstName)m.push('firstName'); if(!s.lastName)m.push('lastName');
      if(!/.+@.+\..+/.test(s.email))m.push('email'); if(!s.mobile)m.push('mobile');
      if(!s.dob)m.push('dob'); if(!s.age)m.push('age');
      /* per-tour age band: block ages outside the tour's range (Age field and/or DOB) */
      if(tourBand()){
        if(s.age && ageOutOfBand(s.age) && m.indexOf('age')<0) m.push('age');
        if(dobOutOfBand(s.dob) && m.indexOf('dob')<0) m.push('dob');
      }
      if(s.ticketType==='mate'){
        if(!s.mates.length) m.push('noMates');
        s.mates.forEach(function(mt,i){
          if(!mt.first)m.push('mate_first_'+i); if(!mt.last)m.push('mate_last_'+i);
          if(!/.+@.+\..+/.test(mt.email))m.push('mate_email_'+i); if(!mt.mobile)m.push('mate_mobile_'+i);
          if(!mt.age)m.push('mate_age_'+i); else if(tourBand() && ageOutOfBand(mt.age))m.push('mate_age_'+i);
          if(!(s.tour&&s.tour.fixedGender) && !mt.gender)m.push('mate_gender_'+i);
          if(s.tour && s.tour.lunch && s.tour.lunch.length && !mt.lunch)m.push('mate_lunch_'+i);
        });
        if(s.tour && s.tour.gendered){
          var nf=(s.identify==='Female'?1:0), nm=(s.identify==='Male'?1:0);
          s.mates.forEach(function(mt){ if(mt.gender==='Female')nf++; else if(mt.gender==='Male')nm++; });
          if(nf>s.tour.femaleSeats || nm>s.tour.maleSeats) m.push('mateAvail');
        } else if(s.tour && groupSize() > s.tour.seats){
          m.push('mateAvail');
        }
      }
    }
    else if (s.step===3){ if(!s.terms)m.push('terms'); if(!s.tc)m.push('tc'); }
    return m;
  }

  function doCheckout(){
    var t = s.tour;
    function variantFor(g){ return t.gendered ? (g==='Female' ? t.femaleVariant : t.maleVariant) : (t.variantId || CONFIG.tourVariants[t.id]); }
    var vid = variantFor(s.identify);
    if (typeof window.Shopify !== 'undefined' && vid && /^\d+$/.test(String(vid))){
      var nMates = s.ticketType==='mate' ? s.mates.length : 0;
      var bookingType = nMates ? ('Group of '+(nMates+1)+' (you + '+nMates+' friend'+(nMates>1?'s':'')+')') : 'Single';
      var props = {
        'City': (t.city || ''),
        'Tour date': t.nice,
        'Age band': t.band,
        'Age': s.age,
        'Age group': s.ageGroup,
        'Gender': s.identify,
        'Goals': s.hopes.join(', '),
        'Energy': s.energy,
        'Relationship status': (s.relationship || ''),
        'Lunch': s.lunch,
        'Instagram': s.instagram,
        'Dietary': s.dietary,
        'Accessibility': s.accessibility,
        'Mobile': fmtPhone(s.mobileCC, s.mobile),
        'DOB': s.dob,
        'Notes': s.note,
        'Booking type': bookingType
      };
      if(nMates) props['Booked with'] = s.mates.map(function(m){ return (m.first+' '+m.last).trim(); }).join(', ');
      if(!t.band) delete props['Age band'];
      if(!s.relationship) delete props['Relationship status'];
      var items = [{ id: vid, quantity: 1, properties: props }];
      if(s.ticketType==='mate') s.mates.forEach(function(m){
        var mprops = {
          'Name': (m.first+' '+m.last).trim(),
          'City': (t.city || ''),
          'Tour date': t.nice,
          'Age band': t.band,
          'Age': m.age,
          'Gender': m.gender,
          'Lunch': m.lunch,
          'Email': m.email,
          'Mobile': fmtPhone(m.mobileCC, m.mobile),
          'Booking type': bookingType,
          'Booked by': (s.firstName+' '+s.lastName).trim()
        };
        if(!t.band) delete mprops['Age band'];
        items.push({ id: variantFor(m.gender), quantity: 1, properties: mprops });
      });
      /* Also write an order-level attendee summary into cart ATTRIBUTES. These appear in the order's
         "Additional details" AND in Shopify's standard orders CSV export (line-item properties do
         NOT export). Purely additive: it does not change the line items, price, the Bring-a-Mate
         discount, validation or checkout, isn't shown to the customer, and the write is best-effort
         (its failure is swallowed) so it can never block a booking. One attribute per attendee, its
         value pipe-delimited so it's easy to split into columns in a sheet. */
      var ATT_FIELDS = ['Name','Mobile','Email','Gender','Age','DOB','Age band','Relationship','Goals','Energy','Lunch','Instagram','Dietary','Accessibility','Notes'];
      function attLine(o){ return ATT_FIELDS.map(function(k){ return (o[k]!=null && String(o[k])!=='') ? (k+': '+o[k]) : null; }).filter(Boolean).join(' | '); }
      var attrs = {};
      attrs['Attendee 1 (Booker)'] = attLine({ 'Name':(s.firstName+' '+s.lastName).trim(), 'Mobile':props['Mobile'], 'Email':s.email, 'Gender':s.identify, 'Age':s.age, 'DOB':s.dob, 'Age band':t.band, 'Relationship':s.relationship, 'Goals':(s.hopes||[]).join(', '), 'Energy':s.energy, 'Lunch':s.lunch, 'Instagram':s.instagram, 'Dietary':s.dietary, 'Accessibility':s.accessibility, 'Notes':s.note });
      if(s.ticketType==='mate') s.mates.forEach(function(m,i){ attrs['Attendee '+(i+2)+' (Mate)'] = attLine({ 'Name':(m.first+' '+m.last).trim(), 'Mobile':fmtPhone(m.mobileCC, m.mobile), 'Email':m.email, 'Gender':m.gender, 'Age':m.age, 'Age band':t.band, 'Lunch':m.lunch }); });

      var btn = root.querySelector('#rsvNext'); if(btn){ btn.textContent = 'Securing your seat…'; btn.disabled = true; }
      /* Start fresh: empty any tickets already in the cart, THEN add just this booking, so
         tickets can never pile up from earlier passes through the flow. */
      fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
        .catch(function(){})   /* clearing is best-effort — never block the booking if it fails */
        .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) }); })
        .then(function(r){ if(!r.ok) throw new Error('add '+r.status);
          return fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ attributes: attrs }) }).catch(function(){}); })  /* attributes = best-effort, never blocks checkout */
        .then(function(){ window.location.href = '/checkout'; })
        .catch(function(){ if(btn){ btn.textContent = 'Proceed to secure checkout →'; btn.disabled = false; } s.errs=['checkout']; s.errMsg='Sorry, we could not reach checkout just now. Please try again in a moment.'; render(); });
    } else {
      go(4); /* local demo confirmation */
    }
  }

  function attemptNext(){
    var m = validate();
    if (m.length===0){ if(s.step===3){ doCheckout(); return; } if(s.step<4) go(s.step+1); return; }
    s.errs = m;
    s.errMsg = hasBandViolation(m) ? bandMsg()
             : (m.indexOf('mateAvail')>-1) ? 'Not enough seats left for your whole group on this tour. Try removing a friend or adjusting the gender mix, or some of you may need another date.'
             : (s.step===0) ? 'Please select a tour to continue.'
             : (s.step===1) ? 'Please answer the highlighted questions to continue.'
             : 'Please complete the highlighted fields to continue.';
    render();
    var first = root.querySelector('.rsv-field.err, .rsv-q.err, .rsv-errbanner');
    if(first) first.scrollIntoView({behavior:'smooth', block:'center'});
  }

  /* ---------- bind events ---------- */
  function bind(){
    var p = root.querySelector('#rsvPanel');

    p.querySelectorAll('[data-tour]').forEach(function(b){ b.addEventListener('click', function(){
      var id=b.getAttribute('data-tour'); s.tour = TOURS.filter(function(t){return t.id===id;})[0];
      go(1);
    });});

    p.querySelectorAll('[data-tt]').forEach(function(b){ b.addEventListener('click', function(){
      s.ticketType = b.getAttribute('data-tt');
      if(s.ticketType==='mate' && s.mates.length===0) s.mates.push(newMate());
      p.querySelectorAll('[data-tt]').forEach(function(x){ x.classList.remove('sel'); });
      b.classList.add('sel');
    });});

    p.querySelectorAll('[data-grp]').forEach(function(b){ b.addEventListener('click', function(){
      var k=b.getAttribute('data-grp'), v=b.getAttribute('data-val'), multi=b.getAttribute('data-multi')==='1';
      if(multi){ var i=s[k].indexOf(v); if(i>-1)s[k].splice(i,1); else s[k].push(v); b.classList.toggle('sel'); }
      else { s[k]=v; p.querySelectorAll('[data-grp="'+k+'"]').forEach(function(x){x.classList.remove('sel');}); b.classList.add('sel'); }
      var q=b.closest('.rsv-q'); if(q) q.classList.remove('err');
    });});


    p.querySelectorAll('[data-f]').forEach(function(inp){
      var ev = (inp.type==='checkbox' || inp.tagName==='SELECT') ? 'change' : 'input';
      inp.addEventListener(ev, function(){
        var key = inp.getAttribute('data-f');
        s[key] = inp.type==='checkbox' ? inp.checked : inp.value;
        var w = inp.closest('.rsv-field'); if(w) w.classList.remove('err');
        /* Date of birth is the source of truth: auto-fill (and lock) the Age field so they always match. */
        if(key==='dob'){
          var a = dobToAge(s.dob);
          s.age = (a!=null) ? String(a) : '';
          var ageInp = p.querySelector('[data-f="age"]');
          if(ageInp){ ageInp.value = s.age; var aw = ageInp.closest('.rsv-field'); if(aw) aw.classList.remove('err'); }
        }
      });
    });

    /* friend text fields */
    p.querySelectorAll('[data-mf]').forEach(function(inp){
      var ev = (inp.tagName==='SELECT') ? 'change' : 'input';
      inp.addEventListener(ev, function(){
        var i = parseInt(inp.getAttribute('data-mate'),10);
        if(s.mates[i]) s.mates[i][inp.getAttribute('data-mf')] = inp.value;
        var w = inp.closest('.rsv-field'); if(w) w.classList.remove('err');
      });
    });

    /* friend gender / lunch pills */
    p.querySelectorAll('[data-mate-grp]').forEach(function(b){ b.addEventListener('click', function(){
      var i = parseInt(b.getAttribute('data-mate'),10);
      var grp = b.getAttribute('data-mate-grp'), v = b.getAttribute('data-val');
      if(s.mates[i]) s.mates[i][grp] = v;
      var block = b.closest('.rsv-mate-block');
      if(block){ block.querySelectorAll('[data-mate-grp="'+grp+'"][data-mate="'+i+'"]').forEach(function(x){ x.classList.remove('sel'); }); }
      b.classList.add('sel');
      var q=b.closest('.rsv-q'); if(q) q.classList.remove('err');
    });});

    /* add / remove friend */
    var addBtn = p.querySelector('[data-add-mate]'); if(addBtn) addBtn.addEventListener('click', function(){ s.mates.push(newMate()); render(); });
    p.querySelectorAll('[data-mate-remove]').forEach(function(b){ b.addEventListener('click', function(){
      var i = parseInt(b.getAttribute('data-mate-remove'),10);
      s.mates.splice(i,1);
      if(s.mates.length===0) s.ticketType='single';
      s.errs=[]; render();
    });});

    p.querySelectorAll('[data-goto]').forEach(function(b){ b.addEventListener('click', function(){ go(parseInt(b.getAttribute('data-goto'),10)); });});
    var bk = p.querySelector('.rsv-back'); if(bk) bk.addEventListener('click', function(){ go(Math.max(0,s.step-1)); });
    var nx = p.querySelector('#rsvNext'); if(nx) nx.addEventListener('click', attemptNext);

    p.querySelectorAll('.rsv-ics').forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); downloadICS(); });});
    var sh=p.querySelector('.rsv-share'); if(sh) sh.addEventListener('click', function(){
      var txt="I just booked "+BRAND_NAME+", "+s.tour.nice+"!";
      if(navigator.share){ navigator.share({title:(BRAND.name || 'Speed Dating Wine Tour'),text:txt}).catch(function(){}); }
      else { try{ navigator.clipboard.writeText(txt); }catch(e){} sh.textContent='✓ Link copied'; }
    });
    var bh=p.querySelector('.rsv-back-home'); if(bh) bh.addEventListener('click', function(){ close(); });
  }

  function downloadICS(){
    var d=s.tour.iso;
    var ics=['BEGIN:VCALENDAR','VERSION:2.0','BEGIN:VEVENT','SUMMARY:Speed Dating Wine Tour',
      'DTSTART:'+d+'T093000','DTEND:'+d+'T180000','DESCRIPTION:'+(s.tour.region||'Valley')+' tour - booking '+s.ref,
      'LOCATION:'+(s.tour.region||'Valley'),'END:VEVENT','END:VCALENDAR'].join('\r\n');
    var a=document.createElement('a'); a.href='data:text/calendar;charset=utf-8,'+encodeURIComponent(ics);
    a.download='sdwt-tour.ics'; document.body.appendChild(a); a.click(); a.remove();
  }

  document.addEventListener('click', function(e){
    var a = e.target.closest('a, button'); if(!a) return;
    if (root && root.contains(a)) return;
    var href = (a.getAttribute('href')||'').toLowerCase();
    var txt  = (a.textContent||'').trim().toLowerCase();
    if (a.hasAttribute('data-reserve') || txt==='register now' || txt==='book now' || /^reserve/.test(txt) || /^book/.test(txt)) {
      e.preventDefault(); var _pre = a.getAttribute('data-reserve'); open(_pre || window.SDWT_PAGE_TOUR || undefined);
    }
  }, true);

  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

  /* Empty a leftover cart from a PREVIOUS visit so returning customers start clean.
     A per-session flag (sessionStorage) tells same-session navigation apart from a brand-new
     visit: within one session the cart is left alone (normal browsing), but a fresh visit that
     still has stale tickets from before gets emptied automatically. */
  function freshSessionCartReset(){
    if (typeof window.Shopify === 'undefined') return;      /* live store only, not the local demo */
    try {
      if (sessionStorage.getItem('sdwt_session')) return;   /* same session -> leave the cart as-is */
      sessionStorage.setItem('sdwt_session', '1');
    } catch(e){ return; }                                   /* storage blocked -> do nothing, never risk wiping mid-session */
    fetch('/cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(c){ if(c && c.item_count > 0){ fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} }); } })
      .catch(function(){});
  }
  freshSessionCartReset();

  window.SDWTReserve = { open: open, close: close };
})();
